import React, { useContext, useEffect, useState } from "react";
import styles from "./ViewIndividualBook.module.css";
import BookInfo from "../../../BookModule.module.css";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Loader from "../../../../../Loader";
import { Star } from "@mui/icons-material";
import { UserContext } from "../../../../../../../context/UserDetails";
import { ImageUrlPrefix, R_PER_PAGE } from "../../../../../../../labels";
import Pagination from "../../../../../../ReusuableComponent/Pagination/Pagination";
import { Rating } from "@mui/material";
import { AxiosInstance } from "../../../../../../../axios";
import moment from "moment";
import avatarImg from "../../../ViewBook/avatarimg.png";
import { useDispatch } from "react-redux";
import {
  setBookFilters,
  setFilters,
} from "../../../../../../../redux/purchaseBookFilterSlice";
import { saveSelectedBooks } from "../../../../../../../redux/CreateBooksetSlice";
import fileDownload from "js-file-download";
import axios from "axios";

function ViewIndividualBook() {
  const { user, logout } = useContext(UserContext);
  let page = R_PER_PAGE;
  const { id } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [ratingReview, setRatingView] = useState();
  const [stockList, setStockList] = useState([]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const location = useLocation();
  const { AUTHOR, PUBLISHER, VISIBLETOUSER, CATEGORY, COURSE, SUBJECT, MEDIUM, PRICE, LABEL, BOOKIDS, IDS } = location.state || {};

  const [initialfields, setInitialfields] = useState({
    bookName: "",
    author: "",
    publisher: "",
    phoneNumber: "",
    isbn_no: "",
    price: "",
    overall_ratings: "",
    no_of_students: "",
    offer_percentage: "",
    finalPrice: "",
    description: "",
    stock_count: "",
    category_name: "",
    group_course_name: "",
    subject_name: "",
    medium: "",
    is_visible: "",
    tags: "",
    weight: "",
    total_pages: "",
    iframe: "",
    dimension: "",
    ebook_url: "",
    preview_path: "",
    original_preview_path: "",
    is_ebook: 0,
    tagLine: "",
    is_free_book: 0,
  });

  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [currentPage, setCurrentPage] = useState(1);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedBookSort, setSelectedBookSort] = useState("asc");

  const SortSelectedBooks = (event, sortKey) => {
    event.preventDefault();

    let order = selectedBookSort === "asc" ? "desc" : "asc";
    setSelectedBookSort(order);

    let sortedList = stockList.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setStockList(sortedList);
  };
  const [rowsPerPageTwo, setRowsPerPageTwo] = useState(5);
  const [currentPageTwo, setCurrentPageTwo] = useState(1);
  const startIndex = (currentPageTwo - 1) * rowsPerPageTwo;
  const endIndex = startIndex + rowsPerPageTwo;
  const totalPagesTwo = Math.ceil(stockList?.length / rowsPerPageTwo);

  const handlePageCountTwo = (e) => {
    const newRowsPerPage = Number(e.target.value);
    setRowsPerPageTwo(newRowsPerPage);
    setCurrentPageTwo(1);
  };

  const handlePrevTwo = () => {
    setCurrentPageTwo((prev) => Math.max(prev - 1, 1));
  };

  const handleNextTwo = () => {
    setCurrentPageTwo((prev) => Math.min(prev + 1, totalPagesTwo));
  };
  const handleBackFilter = () => {

    if (LABEL == "Back to View Bookset") {
     
      navigate(`/studyMaterials/Books/ViewBookSet/${BOOKIDS}/${IDS}`, {
        state: {
       
          filauthor: AUTHOR,
          filpublisher: PUBLISHER,
          filvisibleToUser: VISIBLETOUSER,
          filcategory: CATEGORY,
          filcourse: COURSE,
          filsubject: SUBJECT,
          filmedium: MEDIUM,
          filprice: PRICE,

        },
      });
    } else {
      navigate(-1);
    }

  };
  const handleNavigate = () => {
    navigate(`/createIndividualBook/${id}`);
  };

  useEffect(() => {
    setStockList(stockList);
  }, [stockList]);
  useEffect(() => {
    setIsLoading(true);
    AxiosInstance.post("api/book/findById", { id: parseInt(id) })
      .then((res) => {
        if (res.data.status === true) {
          setRatingView(res.data.ratings_reviews);
          const fiata = res.data.data.stockHistory;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setStockList(serialNumberAddedData);
          setInitialfields({
            bookName: res.data.data.book_title,
            author: res.data.data.author,
            publisher: res.data.data.publisher,
            isbn_no: res.data.data.isbn_no,
            overall_ratings: res.data.data.overall_ratings,
            no_of_students: res.data.data.no_of_students,
            price: res.data.data.price,
            offer_percentage: res.data.data.offer_percentage,
            finalPrice: res.data.data.finalPrice,
            description: res.data.data.description,
            stock_count: res.data.data.stock_count,
            category_name: res.data.data.category_name,
            group_course_name: res.data.data.group_course_name,
            subject_name: res.data.data.subject_name,
            medium: res.data.data.medium,
            is_visible: res.data.data.is_visible,
            tags: res.data.data.tags,
            tagLine: res.data.data.tag_line,
            weight: res.data.data.weight,
            total_pages: res.data.data.total_pages,
            // iframe: res.data.data.iframe,
            iframe: res.data.data.iframe,
            // iframe: res.data.data.iframe
            //   ? res.data.data.iframe.match(/src="([^"]*)"/)?.[1] ||
            //     res.data.data.iframe
            //   : "", // Extract src from iframe tag
            dimension: res.data.data.dimension,
            ebook_url: res.data.data.ebook_url,
            preview_path: res.data.data.preview_path,
            original_preview_path: res.data.data.original_preview_path,
            is_ebook: res.data.data.is_ebook,
            images: res.data.data.images,
            is_free_book: res.data.data.is_free_book,
          });
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        return error;
      });
  }, [id]);
  const start = (currentPageTwo - 1) * rowsPerPageTwo;
  const end = start + rowsPerPageTwo;
  const currentData = stockList?.slice(start, end);

  //pagination

  const totalPages = Math.ceil(stockList?.length / rowsPerPage);
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    // setUpdateListData([]);
    // loadListdata();
  };

  const getYouTubeID = (url) => {
    const regExp =
      /(?:youtube\.com\/(?:.*[?&]v=|v\/|embed\/|shorts\/)|youtu\.be\/)([^"&?\/\s]{11})/;
    const match = url.match(regExp);
    return match ? match[1] : "";
  };
  const handleDownload = (url, filename) => {
    axios
      .get(`${ImageUrlPrefix}/${initialfields.preview_path}`, {
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, filename);
      })
      .catch((error) => {
        console.error("Download failed:", error);
      });
  };
  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${styles.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">View Book</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                onClick={handleBackFilter}
                to="javascript:void(0)"
                className="secondaryButton "
                variant="secondary"
              >
                {/* {id ? "Back To Create New Purchase" : "Back to Books"} */}
                {LABEL || "Back to Books"}
              </Link>
            </li>
            {LABEL == "Back to Books" && (
              <li class="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  // onClick={() => handleNavigate(id)}
                  onClick={handleNavigate}
                  className="primaryButton"
                  variant="primary"
                >
                  {" "}
                  <span className="material-icons me-1 fs-5 align-middle text-white">
                    border_color
                  </span>{" "}
                  Edit Book
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
      <div className="mb-4">
        <fieldset className="mt-3">
          <legend className="w-auto">Book Type</legend>
          <div className="row mb-3">
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Is this an e-book?</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.is_ebook == 1 ? "Yes" : "No" || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Is this a free book?</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.is_free_book == 1 ? "Yes" : "No" || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Visible to Users</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.is_visible == 1 ? "Yes" : "No"}
                </p>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset className="mt-3">
          <legend className="w-auto">Book Details</legend>
          <div className="row mb-3">
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Book Name</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.bookName || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Author</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.author || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Publisher</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.publisher || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> ISBN Number</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.isbn_no || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Total Number of Pages</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.total_pages || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <div className="d-flex">
                  <p className="confirm_label m-0 p-0">
                    {" "}
                    Sample Pages (in PDF)
                  </p>{" "}
                  {initialfields.preview_path !== "" &&
                    initialfields.preview_path !== null && (
                      <>
                        <a
                          // href={`${ImageUrlPrefix}/${initialfields.original_preview_path}`}
                          to="javascript:void(0)"
                          onClick={() =>
                            handleDownload(
                              initialfields.preview_path,
                              initialfields.original_preview_path
                            )
                          }
                          // target="_blank"
                          download
                        >
                          <span className="material-icons align-middle download_icon">
                            file_download
                          </span>
                        </a>
                      </>
                    )}
                </div>

                <p className="confirm_value my-1 m-0 p-0">
                  {initialfields.original_preview_path || "_"}
                </p>
              </div>
            </div>
            {/* tag Line */}
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Short Description</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.tagLine || "_"}
                </p>
              </div>
            </div>
            {/* <div className="my-1  col-md-12 ">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Iframe URL</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.iframe || "_"}
                </p>
              </div>
            </div> */}
            <div className="my-1  col-md-12 ">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0">Detailed Description</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.description || "_"}
                </p>
              </div>
            </div>
          </div>
        </fieldset>

        {initialfields?.iframe && (
          <fieldset className="mt-3">
            <legend className="w-auto">YouTube URL</legend>
            <div className="row">
              <div className="my-1 col-lg-12 col-md-12 col-12 text-center">
                <iframe
                  src={`https://www.youtube.com/embed/${getYouTubeID(
                    initialfields.iframe
                  )}`}
                  className={`${styles.iframeVideo}`}
                  allowFullScreen
                  title="Dynamic Iframe"
                ></iframe>
              </div>
            </div>
          </fieldset>
        )}

        {initialfields.is_ebook !== 1 && (
          <fieldset className="mt-3">
            <legend className="w-auto">Stock Count</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Stock Count</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {initialfields.stock_count || "0"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        )}

        <fieldset className="mt-3">
          <legend className="w-auto">Price</legend>
          <div className="row mb-3">
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> MRP</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.price || "0"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Offer Percentage</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.offer_percentage || "0"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Final Price</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.finalPrice || "0"}
                </p>
              </div>
            </div>
          </div>
        </fieldset>
        <fieldset className="mt-3">
          <legend className="w-auto">Course Details</legend>
          <div className="row mb-3">
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Category</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.category_name || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Course</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.group_course_name || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Subject</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.subject_name || "_"}
                </p>
              </div>
            </div>
            <div className="my-1 col-lg-3 col-md-3 col-12">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Medium</p>
                <p className="confirm_value my-1 m-0 p-0">
                  {" "}
                  {initialfields.medium || "_"}
                </p>
              </div>
            </div>
          </div>
        </fieldset>
        {initialfields.is_ebook == 0 ? (
          <fieldset className="mt-3">
            <legend className="w-auto">Dimension and Weight</legend>
            <div className="row mb-3">
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Dimension (in cm)</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {initialfields.dimension || "_"}
                  </p>
                </div>
              </div>
              <div className="my-1 col-lg-3 col-md-3 col-12">
                <div className="d-flex flex-column">
                  <p className="confirm_label m-0 p-0"> Weight (in kg)</p>
                  <p className="confirm_value my-1 m-0 p-0">
                    {" "}
                    {initialfields.weight || "_"}
                  </p>
                </div>
              </div>
            </div>
          </fieldset>
        ) : (
          <div></div>
        )}
        <fieldset className="mt-3">
          <legend className="w-auto">Tags</legend>
          <div className="row mb-3">
            <div className="my-1  col-md-12 ">
              <div className="d-flex flex-column">
                <p className="confirm_label m-0 p-0"> Tags</p>
                <p className="confirm_value  m-0 p-0">
                  {" "}
                  <ul
                    className={` p-0 mt-2 d-flex flex-wrap ${styles.BookTagchip}`}
                  >
                    {initialfields.tags.length > 0 &&
                      initialfields.tags.map((item) => {
                        return (
                          <li>
                            <a
                              href="javascript:void(0)"
                              className={styles.BookTagChipLabel}
                            >
                              {item.tag_name}
                            </a>
                          </li>
                        );
                      })}
                  </ul>
                </p>
              </div>
            </div>
          </div>
        </fieldset>
        {/* <fieldset className="mt-3">
                    <legend className="w-auto">Uploaded Images</legend>
                    <div className="row mb-2 mt-2" >
                        {initialfields.images?.map((item) => {
                            return (
                                <div className={`col-md-3 `} >
                                    <div className={`${styles.cardCenterAlign}`}>
                                        <img
                                            src={`${ImageUrlPrefix}/${item.book_image_path}`}
                                            alt="Book Image"
                                            className={`${styles.bookImage}`}
                                        />
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                </fieldset> */}
        <fieldset className="mt-3">
          <legend className="w-auto">Uploaded Images</legend>
          <div className="row mb-2 mt-2">
            {initialfields.images?.length > 0 ? (
              initialfields.images?.map((item) => {
                return (
                  <div className={`col-md-3 `}>
                    <div className={`${styles.cardCenterAlign}`}>
                      <img
                        src={`${ImageUrlPrefix}/${item.book_image_path}`}
                        alt="Book Image"
                        className={`${styles.bookImage}`}
                      />
                    </div>
                  </div>
                );
              })
            ) : (
              <p className="text-center confirm_value my-1 m-0 p-0">
                No images available
              </p>
            )}
          </div>
        </fieldset>
        <div className="row mt-3">
          <div className="col-xl-12 col-lg-12 col-md-12 col-12">
            <fieldset className={BookInfo.CourierContainer}>
              <legend className="w-auto mb-0">Stock Lists</legend>
              <div className="row mx-0 mt-4">
                <div className="col-md-12 table-responsive tableMinHeight px-0">
                  <table className="table" id="tableListHeader">
                    <thead>
                      <tr>
                        <th id="th" className={BookInfo.tableThPadding}>
                          <span
                            className="textHead_th"
                            onClick={(e) =>
                              SortSelectedBooks(e, "serialNumber")
                            }
                          >
                            S.No.
                          </span>
                          <span
                            className={`textHead_th material-icons align-middle`}
                            onClick={(e) =>
                              SortSelectedBooks(e, "serialNumber")
                            }
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={BookInfo.tableThPadding}>
                          <span
                            className="textHead_th"
                            onClick={(e) => SortSelectedBooks(e, "stock_count")}
                          >
                            Added Stock Count
                          </span>
                          <span
                            className={`textHead_th material-icons align-middle`}
                            onClick={(e) => SortSelectedBooks(e, "stock_count")}
                          >
                            import_export{" "}
                          </span>
                        </th>
                        <th id="th" className={BookInfo.tableThPadding}>
                          <span
                            className="textHead_th"
                            onClick={(e) => SortSelectedBooks(e, "created_dt")}
                          >
                            Added Date
                          </span>
                          <span
                            className={`textHead_th material-icons align-middle`}
                            onClick={(e) => SortSelectedBooks(e, "created_dt")}
                          >
                            import_export{" "}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentData?.length === 0 ? (
                        <tr>
                          <td colSpan="15" style={{ textAlign: "center" }}>
                            No records to display
                          </td>
                        </tr>
                      ) : (
                        Array.isArray(currentData) &&
                        currentData?.map((book, index) => (
                          <tr key={index}>
                            {/* <td id="td">{index +1}</td> */}
                            <td id="td">{book.serialNumber}</td>
                            <td id="td">
                              <span>{book.stock_count}</span>
                            </td>
                            <td id="td">
                              <span>
                                {book.created_dt
                                  ? moment
                                    .utc(book.created_dt)
                                    .format("YYYY-MM-DD HH:mm")
                                  : "_"}
                              </span>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row mt-2">
                <Pagination
                  rowsPerPage={rowsPerPageTwo}
                  handlePageCount={handlePageCountTwo}
                  startPage={stockList?.length > 0 ? startIndex + 1 : 0}
                  endPage={
                    stockList?.length > 0
                      ? Math.min(endIndex, stockList?.length)
                      : 0
                  }
                  totalRecords={stockList?.length}
                  handlePrev={handlePrevTwo}
                  currentPrevPage={currentPageTwo === 1}
                  prevButton={`${BookInfo.prev_buttonViewAllbook} ${BookInfo.materialIconsRightAndLeft} me-2`}
                  handleNext={handleNextTwo}
                  currentNextPage={
                    currentPageTwo >= totalPagesTwo || totalPagesTwo == 0
                  }
                />
              </div>
            </fieldset>
          </div>
        </div>
        {ratingReview?.length > 0 && (
          <fieldset className="mt-3">
            <legend className="w-auto">Ratings and Reviews</legend>

            {/* {initialfields.is_optional == 1 && ( */}
            {ratingReview?.length > 0 &&
              ratingReview?.map((item) => {
                return (
                  <>
                    <div className="  mt-2">
                      <div className="ulFilterListData d-flex">
                        {initialfields.overall_ratings && (
                          <div className="filterListData col-md-6">
                            <div
                              className={`${BookInfo.ratings_star_icon} mb-2 mb-md-0`}
                            >
                              <p className={`${BookInfo.rating_title} mb-0`}>
                                {initialfields.overall_ratings}
                                <Star className={BookInfo.star_icon} />
                              </p>
                            </div>
                            <div className="text-center W-100">
                              <p
                                className={`mb-0 ${BookInfo.BookSubTitle} text-start`}
                              >
                                {`(based on ${initialfields.no_of_students} ratings and reviews given by our
                        students)`}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="borderWidth  mt-2">
                      <div className="row">
                        <div className="col-md-12 ">
                          <div className="d-flex mt-2">
                            <div className="">
                              {item.profile_path ? (
                                <img
                                  src={`${ImageUrlPrefix}/${item.profile_path}`}
                                  alt="Book Image"
                                  className={`${styles.userProfileImage}`}
                                />
                              ) : (
                                <img
                                  src={avatarImg}
                                  alt="Book Image"
                                  className={`${styles.userProfileImage}`}
                                />
                              )}
                            </div>
                            <div className={`${styles.userProfileName} `}>
                              <p className={`${styles.reviewUserName} m-0`}>
                                {" "}
                                {item.username} {"  "}{" "}
                                {`(${moment(item.date).format("DD/MM/YYYY")})`}
                              </p>
                              <div className="mt-1">
                                <Rating
                                  name="simple-controlled"
                                  sx={{
                                    "& .MuiRating-iconFilled": {
                                      color: "#c0272d", // Set filled icon color
                                    },
                                    "& .MuiRating-iconHover": {
                                      color: "#c0272d", // Set hover color
                                    },
                                    margin: 0,
                                  }}
                                  value={item.rating} // Use the rating state to control the selected stars
                                  readOnly // This will stop hover interactions
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <p className={`${styles.reviewUserComment} mt-2`}>
                            {/* {initialfields.address} */}
                            {item.review}
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}

            {/* // )} */}

            <div className="borderWidth  mt-2">
              <div className="row mt-2">
                <Pagination
                  rowsPerPage={rowsPerPage}
                  handlePageCount={handlePageCount}
                  startPage={
                    stockList && stockList?.length > 0
                      ? currentPage * rowsPerPage + 1 - rowsPerPage
                      : 0
                  }
                  endPage={
                    stockList && stockList?.length > 0
                      ? stockList?.length < currentPage * rowsPerPage
                        ? stockList?.length
                        : currentPage * rowsPerPage
                      : 0
                  }
                  totalRecords={
                    stockList && stockList?.length > 0 ? stockList?.length : 0
                  }
                  handlePrev={(e) => handlePrev(currentPage - 1)}
                  currentPrevPage={currentPage === 1}
                  prevButton={`${styles.prev_buttonViewEvaluator} ${styles.materialIconsRightAndLeft} me-2`}
                  handleNext={() => handleNext(currentPage + 1)}
                  currentNextPage={
                    currentPage === totalPages || totalPages == 0
                  }
                />
              </div>
            </div>
          </fieldset>
        )}
      </div>
    </div>
  );
}

export default ViewIndividualBook;
